<template slot="reports" slot-scope="props">
  <tr
    style="cursor: pointer;"
    :class="{ 'blue lighten-5': selected, 'green lighten-5': newReport }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
    @click="detailDialog = true"
  >
    <!-- <td @click.stop>
            <v-checkbox
            v-model="selected"
            :color="$store.state.global.pages.docket.color"
            hide-details
            ></v-checkbox>
    </td>-->

    <td v-for="(header,i) in headers" :key="i">
      <span
        v-if="
                typeof getObjectPath(header.value, report) =='string' && 
                (
                    header.value.indexOf('date') == -1 && 
                    header.value.indexOf('updated') == -1 && 
                    header.value.indexOf('created') == -1 
                )
            "
      >{{ getObjectPath(header.value, report)|| "-" }}</span>
      <span
        v-if="
                typeof getObjectPath(header.value, report) =='string' && 
                (
                    header.value.indexOf('date') > -1 || 
                    header.value.indexOf('updated') > -1 || 
                    header.value.indexOf('created') > -1 
                )
                "
      >{{ makeShortDate(getObjectPath(header.value, report))|| "-" }}</span>
      <span
        v-if="
                typeof getObjectPath(header.value, report) =='number' && 
                header.value.indexOf('Id') == -1 && 
                header.value.indexOf('id') == -1
            "
        class="text-xs-right"
      >{{ displayDecimal(getObjectPath(header.value, report),2) || "-" }}</span>
      <span
        v-if="
                typeof getObjectPath(header.value, report) =='number' && 
                (
                    header.value.indexOf('Id') > -1 ||  
                    header.value.indexOf('id') > -1
                )
            "
        class="text-xs-right"
      >{{ getObjectPath(header.value, report) || "-" }}</span>
      <!-- <span v-if="header.type == 'date'">
                {{ makeShortDate(getObjectPath(header.value, report)) || "-" }}
            </span>
            <span v-if="header.type == 'time'">
                {{ makeTime(getObjectPath(header.value, report)) || "-" }}
            </span>
            <span v-if="header.type == 'num'">
                {{ displayDecimal(getObjectPath(header.value, report),header.decimals) || "-" }}
            </span>
            <span v-if="header.type == 'curr' ">
                {{ !!getObjectPath(header.value, report) ? `$ ${displayDecimal(getObjectPath(header.value, report),header.decimals)}` : "-" || "" }}
            </span>
            <span v-if="header.type == 'text'">
                {{ getObjectPath(header.value, report) || "-" }}
      </span>-->
    </td>
    <!-- END CELLS -->
  </tr>
</template>

<script>
import FormatDates from "@/services/mixins/formatDates";
import Store from "@/store/computed/storeHelpers";

export default {
  mixins: [FormatDates],
  data() {
    return {
      newReport: this.report.new,
      hover: false,
      editDialog: false,
      detailDialog: false,
      deleteDialog: false,
      actionConfirmationDialog: false,
      docketDialog: false,
      actionsMenu: false,
      currentNotes: "",
      fieldData: {}
    };
  },
  methods: {
    actionComplete() {
      this.fieldData = {};
      this.actionConfirmationDialog = false;
    },
    deleteReport() {
      this.deleteDialog = true;
      // //console.log(this.report)
      // DocketService.deleteReport(this.report.id).then( result => {
      //     this.$store.commit("reports/deleteFromArrayStateByValue", {prop: 'reports', value: this.report})
      // })
    },
    editReport() {
      this.editDialog = true;
    },
    viewDocketDialog() {
      this.docketDialog = true;
    },
    confirmUpdateReportField(payload) {
      this.fieldData = payload;
      this.currentNotes = this.report[payload.notesField];
      this.actionConfirmationDialog = true;
    },
    displayCurrency(val) {
      if (!!val) {
        return `$${val.toFixed(2)}`;
      } else {
        return "-";
      }
    },
    displayDecimal(val, decimals) {
      if (!!val) {
        return `${val.toFixed(decimals)}`;
      } else {
        return "-";
      }
    }
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", { value: val, object: this.report });
      }
    }
  },
  mounted() {
    if (this.report.new) {
      setTimeout(() => {
        this.newReport = false;
      }, 10000);
    }
  },
  props: {
    report: Object,
    headers: Array,
    value: Boolean
  }
};
</script>

<style scoped>
.v-input--selection-controls .v-input__slot {
  margin-bottom: 3px;
}
.new {
  border-left: solid 4px;
  border-color: var(--v-success-base) !important;
}
</style>
